import Canvas from "./Canvas.component";

export default Canvas;
